import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_OFFER2_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_OFFER2_75,
  },
  {
    pageId: PageId.CHAT_UPSELL_OFFER2_75,
  },
  {
    pageId: PageId.UPSELL_OFFER2_75,
  },
  {
    pageId: PageId.DOWNLOAD_OFFER2_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
